<template>
  <div id="app">
    <FullScreenVideo v-if="step === 0" :next="next" />
    <Welcome v-if="step === 1" :next="next" />
    <People18 v-if="step === 2" :next="next" />
    <Detail v-if="step === 3" :back="back" :next="next" />
    <RandomHear v-if="step === 4" :back="back" :next="next" />
    <Greeting v-if="step === 5" :next="next" :goToDetail="goToDetail" />
    <End v-if="step === 6" :back="goToFloat" />
  </div>
</template>

<script>
import FullScreenVideo from "./components/fullscreen-video.vue";
import Welcome from "./components/welcome.vue";
import People18 from "./components/people18.vue";
import Detail from "./components/detail.vue";
import RandomHear from "./components/randomHear.vue";
import Greeting from "./components/greeting.vue";
import End from "./components/end.vue";

export default {
  components: {
    FullScreenVideo,
    Welcome,
    People18,
    Detail,
    RandomHear,
    Greeting,
    End,
  },
  data() {
    return {
      step: 0,
    };
  },

  methods: {
    next() {
      this.step++;
    },
    back() {
      this.step--;
    },
    jump(i) {
      this.step = i;
    },
    goToDetail() {
      this.step = 3;
    },
    goToFloat() {
      this.step = 4;
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: FangSong;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.nice-scroll::-webkit-scrollbar {
  background-color: transparent;
  width: 8px;
  height: 8px;
}

.nice-scroll::-webkit-scrollbar-thumb {
  background-color: gray;
  border-radius: 4px;
}
</style>
